import React, { useEffect, useRef, useState } from "react";
import InnerLayout from "../components/layouts/inner-layout";
import ItemsInputFieldStandalone from "../components/forms/standalone-input-field";
import { ArrowRight, SearchIcon } from "lucide-react";
import AddButton from "../components/buttons/button";
import FilterIcon from "../assets/icons/filter-icon";
import TabsComponent from "../components/helper-components/tabs-component";
import DatePickerInput from "../components/forms/date-picker";
import { useDispatch } from "react-redux";
import {
  stockDetailsItemViewAction,
  stockDetailsItemsFetchAction,
  stockDetailsWarehouseLocationAction,
} from "../redux/actions/stock-details-audit-action";
import LoadingSpinner from "../components/helper-components/loading-spinner";
import InfiniteScroll from "react-infinite-scroll-component";
import { truncateString } from "../components/helper-components/helper-function";
import { debounce } from "lodash";
import DetailsIcon from "../assets/icons/details-icon";
import { useNavigate } from "react-router-dom";
import StockDetailsTable from "../components/tables/stock-details-table";
import {
  storesItemParamedAction,
} from "../redux/actions/general-action";
import { isAdmin } from "../redux/config";
import StockDetailsBatchPanel from "../components/inventory/stock-details/stock-details-batch-panel";
import StockDetailsFilter from "../components/inventory/stock-details/stock-details-filter";

const StockDetails = () => {
  const [data, setData] = useState([]);
  const initFilter = {
    search: "",
    stock_status: "",
    expiry_status: "",
    rx_drugs: "",
  };
  const [batchOpen, setBatchOpen] = useState(false);
  const navigate = useNavigate();
  const filterPopupRef = useRef(null);
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState("Batches");
  const [filterData, setFilterData] = useState(initFilter);
  const [selectedItemId, setSelectedItemId] = useState("");

  const productDetails =
    items?.find((item) => item?.item_id === selectedItemId) || {};
  const itemTabs = [
    "Batches",
    "Purchases",
    "Sales",
    "Alternatives",
    "Vendors",
    "Time Line",
    "Other Stores",
    "Warehouse Location",
  ];
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_pages: 1,
    has_next: false,
    has_previous: false,
  });

  useEffect(() => {
    dispatch(
      stockDetailsItemsFetchAction(
        { page_no: page, ...filterData },
        (data) => {
          setLoading(false);
          const p = data?.data?.pagination;
          const newItems = data?.data?.items || [];

          if (page === 1) {
            setItems(newItems);
            setSelectedItemId(newItems[0]?.item_id);
          } else {
            setItems((prev) => [...prev, ...newItems]); // append for other pages
          }

          setPagination(p);
        },
        () => {
          setLoading(false);
          if (page === 1) setItems([]);
          setData([]);
          setSelectedItemId("");
        }
      )
    );
  }, [page, filterData]);

  // Load more simply increments the page
  const handleLoadMore = () => {
    if (pagination.has_next) {
      setPage((prev) => prev + 1);
    }
  };

  // When filter changes, reset page to 1
  useEffect(() => {
    setPage(1);
  }, [filterData]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        showFilter &&
        filterPopupRef.current &&
        !filterPopupRef.current.contains(event.target)
      ) {
        setShowFilter((prevShowFilter) => !prevShowFilter);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showFilter]);

  const debouncedSearch = useRef(
    debounce((val) => {
      setFilterData((prev) => ({ ...prev, search: val }));
    }, 400)
  ).current;
  //ITEM DETAILS FILTER

  const [currentBatch, setCurrentBatch] = useState({});
  const [dataCount, setDataCount] = useState(0);
  const [dataLoading, setDataLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const initItemDetailsFilter = {
    tab_type: "batches",
    item_id: selectedItemId,
    search: "",
    page_no: 1,
    sortBy: "",
    sortOrder: "",
    fromDate: "",
    toDate: "",
    state: "",
    district: "",
    City: "",
  };
  const [itemDetailsFilter, setItemDetailsFilter] = useState(
    initItemDetailsFilter
  );
  useEffect(() => {
    // Other Stores is fetched by its own effect below
    if (itemDetailsFilter?.tab_type === "otherstores") return;
    if (selectedItemId) {
      setDataLoading(true);
      if (itemDetailsFilter?.tab_type === "warehouselocation") {
        dispatch(
          stockDetailsWarehouseLocationAction(
            { item_id: selectedItemId },
            onWarehouseLocationSuccess,
            onError
          )
        );
        return;
      }
      dispatch(
        stockDetailsItemViewAction(
          {
            tab_type: itemDetailsFilter?.tab_type || "",
            item_id: selectedItemId,
            search: itemDetailsFilter?.search || "",
            page_no: paginationProps?.currentPage || 1,
            sortBy: itemDetailsFilter?.sortBy || "",
            sortOrder: itemDetailsFilter?.sortOrder || "",
            fromDate: itemDetailsFilter?.fromDate || null,
            toDate: itemDetailsFilter?.toDate || null,
            state: itemDetailsFilter?.state || "",
            district: itemDetailsFilter?.district || "",
            city: itemDetailsFilter?.city || "",
          },
          onSuccess,
          onError
        )
      );
    } else {
      setData([]);
    }
  }, [selectedItemId, itemDetailsFilter, currentPage]);

  const onSuccess = (data) => {
    setDataLoading(false);
    setDataCount(data?.data?.pagination?.total_items || 0);
    setData(
      data?.data?.batchlist ||
        data?.data?.purchaselist ||
        data?.data?.saleslist ||
        data?.data?.alternativelist ||
        data?.data?.vendorlist ||
        data?.data?.timeLinesData ||
        data?.data ||
        []
    );
  };
  const onError = (data) => {
    setDataLoading(false);
    setData([]);
  };
  const onWarehouseLocationSuccess = (data) => {
    const rows = data?.data || [];
    setDataLoading(false);
    setDataCount(rows.length);
    setData(
      rows.map((row) => ({
        ...row,
        is_expired_bin_location: row?.is_expired_bin_location ? "Yes" : "No",
        is_non_sellable_bin_location: row?.is_non_sellable_bin_location
          ? "Yes"
          : "No",
      }))
    );
  };

  // OTHER STORES
  const storesItemDebounceRef = useRef(null);
  useEffect(() => {
    if (itemDetailsFilter?.tab_type !== "otherstores" || !selectedItemId) {
      return;
    }
    if (storesItemDebounceRef.current) {
      clearTimeout(storesItemDebounceRef.current);
    }
    storesItemDebounceRef.current = setTimeout(() => {
      setDataLoading(true);
      // excluded / pos_id are set in the saga based on isAdmin
      dispatch(
        storesItemParamedAction(
          {
            item_id: selectedItemId,
            page: currentPage || 1,
            limit: pageSize || 10,
          },
          onOtherStoresSuccess,
          onError
        )
      );
    }, 300);
    return () => {
      if (storesItemDebounceRef.current) {
        clearTimeout(storesItemDebounceRef.current);
      }
    };
  }, [
    itemDetailsFilter?.tab_type,
    selectedItemId,
    currentPage,
    pageSize,
  ]);
  const onOtherStoresSuccess = (data) => {
    const rows = data?.data?.stores || [];
    setDataLoading(false);
    setDataCount(data?.data?.pagination?.total || 0);
    setData(rows);
  };

  const [BatchesHeading, setBatchesHeading] = useState([]);
  const [purchaseHeading, setpurchaseHeading] = useState([]);
  const [salesHeading, setSalesHeading] = useState([]);
  const [alternativesHeading, setAlternativesHeading] = useState([]);
  const [vendorsHeading, setVendorsHeading] = useState([]);
  const [timeLineHeading, setTimeLineHeading] = useState([]);

  useEffect(() => {
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const stock_details_batch_tab = parsed.find(
        (obj) => obj?.stock_details_batch_tab
      );
      const stock_details_purchase_tab = parsed.find(
        (obj) => obj?.stock_details_purchase_tab
      );
      const stock_details_sales_tab = parsed.find(
        (obj) => obj?.stock_details_sales_tab
      );
      const stock_details_alternative_tab = parsed.find(
        (obj) => obj?.stock_details_alternative_tab
      );
      const stock_details_vendors_tab = parsed.find(
        (obj) => obj?.stock_details_vendors_tab
      );
      const stock_details_timeline_tab = parsed.find(
        (obj) => obj?.stock_details_timeline_tab
      );
      if (stock_details_batch_tab?.stock_details_batch_tab) {
        setBatchesHeading(stock_details_batch_tab.stock_details_batch_tab);
      }
      if (stock_details_purchase_tab.stock_details_purchase_tab) {
        setpurchaseHeading(
          stock_details_purchase_tab.stock_details_purchase_tab
        );
      }
      if (stock_details_sales_tab.stock_details_sales_tab) {
        setSalesHeading(stock_details_sales_tab.stock_details_sales_tab);
      }

      if (stock_details_alternative_tab?.stock_details_alternative_tab) {
        setAlternativesHeading(
          stock_details_alternative_tab?.stock_details_alternative_tab
        );
      }
      if (stock_details_vendors_tab.stock_details_vendors_tab) {
        setVendorsHeading(stock_details_vendors_tab.stock_details_vendors_tab);
      }
      if (stock_details_timeline_tab?.stock_details_timeline_tab) {
        setTimeLineHeading(
          stock_details_timeline_tab.stock_details_timeline_tab
        );
      }
    }
  }, []);

  return (
    <InnerLayout title="Stock Details" backBtn={true}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="w-full h-full flex">
          <div className="max-w-[25%]  border-r border-r-[var(--layout-border-color)]">
            <div className="max-h-[8rem] min-h-[8rem] px-[24px] sticky top-0 z-30 bg-[var(--stock-det-left-bg)] overflow-auto">
              <div className="flex flex-wrap gap-x-5 items-center pt-[1.5rem]">
                <h2
                  className=" font-[var(--stock-det-head-fw)]
            text-[length:var(--stock-det-head-fs)]
            text-[var(--stock-det-head-fg)]"
                >
                  Stock In Hand
                </h2>
                <div className="flex gap-2 items-center">
                  <div className="flex items-center gap-1">
                    <label
                      className=" font-[var(--stock-det-head-lab-fw)]
            text-[length:var(--stock-det-head-lab-fs)]
            text-[var(--stock-det-head-lab-fg)]"
                    >
                      SKU:
                    </label>
                    <span
                      className=" font-[var(--stock-det-head-val-fw)]
            text-[length:var(--stock-det-head-val-fs)]
            text-[var(--stock-det-head-val-fg)]"
                    >
                      {pagination?.total_items}
                    </span>
                  </div>
                  <div>
                    <ArrowRight size={"14px"} />
                  </div>
                  <div className="flex items-center gap-1">
                    <label
                      className=" font-[var(--stock-det-head-lab-fw)]
            text-[length:var(--stock-det-head-lab-fs)]
            text-[var(--stock-det-head-lab-fg)]"
                    >
                      Stock Value:{" "}
                    </label>
                    <span
                      className=" font-[var(--stock-det-head-val-fw)]
            text-[length:var(--stock-det-head-val-fs)]
            text-[var(--stock-det-head-val-fg)]"
                    >
                      {pagination?.stock_value || 0}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-4 pt-[1.5rem]">
                <ItemsInputFieldStandalone
                  label="Name"
                  leftIcon={
                    <SearchIcon
                      className="text-[var(--stand-alone-place-color)]"
                      size={"15px"}
                    />
                  }
                  isLabelReq={false}
                  placeholder="Search"
                  value={filterData.name}
                  onChange={(e) => debouncedSearch(e.target.value)}
                  className="min-w-[100px]"
                />
                <div ref={filterPopupRef} className="relative">
                  <AddButton
                    icon={<FilterIcon width="14px" />}
                    text="Filter"
                    className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
            bg-[var(--general-button-bg)] cursor-pointer 
            border border-[var(--general-button-border)] 
            hover:bg-[var(--general-button-bg)]
            font-[var(--general-button-fw)]
            text-[length:var(--general-button-fs)]
            text-[var(--general-button-fg)]`}
                    onclkFn={() => {
                      setShowFilter((prevShowFilter) => !prevShowFilter);
                    }}
                  />
                  {showFilter ? (
                    <div className="absolute right-0 top-full mt-2 z-40">
                    <StockDetailsFilter
                      initFilter={initFilter}
                      setPagination={setPagination}
                      filterData={filterData}
                      setFilterData={setFilterData}
                    />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div
              style={{
                maxHeight: `calc(100% - 8rem)`,
                minHeight: `calc(100% - 8rem)`,
                height: `calc(100% - 8rem)`,
              }}
            >
              <div
                className="h-full overflow-x-auto scrollbar-rounded mt-5"
                id="scrollableDiv"
              >
                <InfiniteScroll
                  className="pl-[24px] pr-[10px] flex flex-col gap-5 h-full cursor-pointer pb-[10px] overflow-x-auto"
                  dataLength={items.length} // length of the current items
                  next={handleLoadMore} // function to fetch more data
                  hasMore={pagination.has_next} // whether more data is available
                  loader={<h4>Loading...</h4>}
                  scrollableTarget="scrollableDiv" // optional if you're scrolling inside a div
                >
                  {items?.map((item) => {
                    const isSelected = selectedItemId === item.item_id;
                    return (
                      <div
                          key={item.id}
                          className={`inline-block min-w-fit p-[2px] rounded-[8px] ${
                            isSelected
                              ? "bg-[var(--primary)] pl-[10px] p-[3px]"
                              : "border border-[var(--stock-det-item-con-border)] rounded-[6px]"
                          }`}
                          onClick={() => setSelectedItemId(item.item_id)}
                      >
                        <div
                          className={`w-auto h-auto p-[10px] ${
                            isSelected
                              ? "bg-[var(--stock-det-item-con-sel-bg)] rounded-[6px]"
                              : ""
                          }`}
                        >
                          <div className="border-b border-b-[var(--stock-det-item-con-border)] flex justify-between items-center">
                            <h3 title={item?.item_name} className="leading-8">
                              {truncateString(item?.item_name, 50)}
                            </h3>
                            {item?.item_schedule && (
                              <div className="flex items-center gap-2">
                                <span
                                  className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-2 py-[2px] border-radius bg-[var(--pill-badge-red-bg)]`}
                                >
                                  {item?.item_schedule === "Schedule A"
                                    ? "RX-A"
                                    : item?.item_schedule === "Schedule B"
                                    ? "RX-B"
                                    : item?.item_schedule === "Schedule C"
                                    ? "RX-C"
                                    : item?.item_schedule === "Schedule D"
                                    ? "RX-D"
                                    : item?.item_schedule === "Schedule H"
                                    ? "RX-H"
                                    : item?.item_schedule === "Schedule AB"
                                    ? "RX-AB"
                                    : "RX-S"}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="mt-[0.5rem] flex flex-wrap items-center gap-x-4 gap-y-1">
                            <div
                              className={`w-fit px-2 py-1 shrink-0 rounded-[8px] font-[var(--status-badge-fw)] text-[length:var(--status-badge-fs)] ${
                                item?.stock_status === "In Stock"
                                  ? "border border-[var(--status-badge-green-border)] bg-[var(--status-badge-green-bg)] text-[var(--status-badge-green-fg)]"
                                  : "border border-[var(--status-badge-red-border)] bg-[var(--status-badge-red-bg)] text-[var(--status-badge-red-fg)]"
                              }`}
                            >
                              {item?.stock_status}
                            </div>

                            <div className="flex items-center gap-1 shrink-0 flex-1 min-w-[100px] whitespace-nowrap overflow-visible">
                              <label className="font-[var(--stock-det-item-con-lab-fw)] text-[length:var(--stock-det-item-con-lab-fs)] text-[var(--stock-det-item-con-lab-fg)]">
                                UOM :
                              </label>
                              <span className="font-[var(--stock-det-item-con-val-fw)] text-[length:var(--stock-det-item-con-val-fs)] text-[var(--stock-det-item-con-val-fg)]">
                                {item?.uom_group_name}
                              </span>
                            </div>

                            <div className="flex items-center gap-1 shrink-0 min-w-[100px] whitespace-nowrap overflow-visible">
                              <label className="font-[var(--stock-det-item-con-lab-fw)] text-[length:var(--stock-det-item-con-lab-fs)] text-[var(--stock-det-item-con-lab-fg)]">
                                Available Qty :
                              </label>
                              <span className="font-[var(--stock-det-item-con-val-fw)] text-[length:var(--stock-det-item-con-val-fs)] text-[var(--stock-det-item-con-val-fg)]">
                                {item?.item_quantity}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </InfiniteScroll>
              </div>
            </div>
          </div>

          {productDetails?.item_name && (
            <div className="w-[75%] pt-[24px]">
              <div className="h-[6rem] px-[24px]">
                <div className="flex justify-between items-center ">
                  <div>
                    <div className="flex items-center gap-2">
                      <h2
                        className=" font-[var(--stock-det-head-fw)]
            text-[length:var(--stock-det-head-fs)]
            text-[var(--stock-det-head-fg)]"
                      >
                        {productDetails?.item_name || ""}
                      </h2>
                      {productDetails?.item_schedule && (
                        <div className="flex items-center gap-2">
                          <span
                            className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-2 py-[3px] border-radius bg-[var(--pill-badge-red-bg)]`}
                          >
                            {true === "Schedule A"
                              ? "RX-A"
                              : true === "Schedule B"
                              ? "RX-B"
                              : true === "Schedule C"
                              ? "RX-C"
                              : true === "Schedule D"
                              ? "RX-D"
                              : true === "Schedule H"
                              ? "RX-H"
                              : true === "Schedule AB"
                              ? "RX-AB"
                              : "RX-S"}
                          </span>
                        </div>
                      )}
                    </div>
                    <p
                      className="font-[var(--stock-det-desc-fw)]
            text-[length:var(--stock-det-desc-fs)]
            text-[var(--stock-det-desc-fg)] mt-[0.2rem]"
                    >
                      {productDetails?.item_generic_name}{" "}
                      {productDetails?.item_manufacturer && "-"}
                      {productDetails?.item_manufacturer}
                    </p>
                  </div>
                  <div className="flex gap-3 items-center">
                    <AddButton
                      onclkFn={() => {
                        navigate(`/add-audit`);
                      }}
                      prefixIcon={false}
                      text="Add To Audit"
                      className="
flex items-center px-[30px] h-[40px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-create-fs)] 
font-[var(--primary-button-font-weight)]"
                      type="submit"
                    />
                    <AddButton
                      onclkFn={() => {
                        navigate(`/view-product/${productDetails?.item_id}`);
                      }}
                      icon={<DetailsIcon />}
                      text="Product Info"
                      className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
            bg-[var(--general-button-bg)] cursor-pointer 
            border border-[var(--general-button-border)] 
            hover:bg-[var(--general-button-bg)] text-[var(--general-button-fg)] font-[var(--general-button-fw)]`}
                    />
                  </div>
                </div>
                <div className="mt-[0.5rem] w-auto flex justify-between items-center flex-wrap gap-y-2">
                  <div
                    className={`w-fit px-2 py-1 rounded-[8px] font-[var(--status-badge-fw)] text-[length:var(--status-badge-fs)] ${
                      productDetails?.stock_status === "In Stock"
                        ? "border border-[var(--status-badge-green-border)] bg-[var(--status-badge-green-bg)] text-[var(--status-badge-green-fg)]"
                        : "border border-[var(--status-badge-red-border)] bg-[var(--status-badge-red-bg)] text-[var(--status-badge-red-fg)]"
                    }`}
                  >
                    {productDetails?.stock_status}
                  </div>

                  <div className="flex items-center gap-8 flex-wrap">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center gap-1">
                        <label className="font-[var(--stock-det-item-con-lab-fw)] text-[length:var(--stock-det-item-con-lab-fs)] text-[var(--stock-det-item-con-lab-fg)]">
                          Purchase UOM Name :
                        </label>
                        <span className="font-[var(--stock-det-item-con-val-fw)] text-[length:var(--stock-det-item-con-val-fs)] text-[var(--stock-det-item-con-val-fg)]">
                          {productDetails?.purchase_pack_name || "--"}
                        </span>
                      </div>

                      <div className="flex items-center gap-1">
                        <label className="font-[var(--stock-det-item-con-lab-fw)] text-[length:var(--stock-det-item-con-lab-fs)] text-[var(--stock-det-item-con-lab-fg)]">
                          Purchase UOM Qty :
                        </label>
                        <span className="font-[var(--stock-det-item-con-val-fw)] text-[length:var(--stock-det-item-con-val-fs)] text-[var(--stock-det-item-con-val-fg)]">
                          {productDetails?.purchase_uom_qty || "--"}
                        </span>
                      </div>
                    </div>

                    <div className="flex items-center gap-4">
                      <div className="flex items-center gap-1">
                        <label className="font-[var(--stock-det-item-con-lab-fw)] text-[length:var(--stock-det-item-con-lab-fs)] text-[var(--stock-det-item-con-lab-fg)]">
                          Sales UOM Name :
                        </label>
                        <span className="font-[var(--stock-det-item-con-val-fw)] text-[length:var(--stock-det-item-con-val-fs)] text-[var(--stock-det-item-con-val-fg)]">
                          {productDetails?.sales_pack_name || "--"}
                        </span>
                      </div>

                      <div className="flex items-center gap-1">
                        <label className="font-[var(--stock-det-item-con-lab-fw)] text-[length:var(--stock-det-item-con-lab-fs)] text-[var(--stock-det-item-con-lab-fg)]">
                          Sales UOM Qty :
                        </label>
                        <span className="font-[var(--stock-det-item-con-val-fw)] text-[length:var(--stock-det-item-con-val-fs)] text-[var(--stock-det-item-con-val-fg)]">
                          {productDetails?.sales_uom_qty || "--"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-1">
                    <label className="font-[var(--stock-det-item-con-lab-fw)] text-[length:var(--stock-det-item-con-lab-fs)] text-[var(--stock-det-item-con-lab-fg)]">
                      UOM :
                    </label>
                    <span className="font-[var(--stock-det-item-con-val-fw)] text-[length:var(--stock-det-item-con-val-fs)] text-[var(--stock-det-item-con-val-fg)]">
                      {productDetails?.uom_group_name}
                    </span>
                  </div>

                  <div className="flex items-center gap-1">
                    <label className="font-[var(--stock-det-item-con-lab-fw)] text-[length:var(--stock-det-item-con-lab-fs)] text-[var(--stock-det-item-con-lab-fg)]">
                      Available Qty :
                    </label>
                    <span className="font-[var(--stock-det-item-con-val-fw)] text-[length:var(--stock-det-item-con-val-fs)] text-[var(--stock-det-item-con-val-fg)]">
                      {productDetails?.item_quantity}
                    </span>
                  </div>
                </div>
              </div>

              <div className="px-[24px] flex justify-between gap-3 items-center  h-[4rem]">
                <div className="w-full">
                  <TabsComponent
                    handleClickfn={(item) => {
                      setCurrentTab(item);
                      setItemDetailsFilter({
                        ...itemDetailsFilter,
                        tab_type:
                          item === "Batches"
                            ? "batches"
                            : item === "Purchases"
                            ? "purchase"
                            : item === "Sales"
                            ? "sales"
                            : item === "Alternatives"
                            ? "alternative"
                            : item === "Vendors"
                            ? "vendors"
                            : item === "Time Line"
                            ? "timeline"
                            : item === "Other Stores"
                            ? "otherstores"
                            : item === "Warehouse Location"
                            ? "warehouselocation"
                            : "",
                        fromDate: "",
                      });
                      setCurrentPage(1);
                    }}
                    itemTabs={itemTabs}
                    setCurrentTab={setCurrentTab}
                    currentTab={currentTab}
                  />
                </div>
                {(currentTab === "Purchases" || currentTab === "Time Line") && (
                  <div
                    style={{
                      width: "fit-content",
                      height: "32px",
                    }}
                    className=" flex items-center gap-2"
                  >
                    <>
                      {" "}
                      <DatePickerInput
                        placeholder="From Date"
                        onChange={(date) => {
                          setItemDetailsFilter({
                            ...itemDetailsFilter,
                            fromDate: date,
                          });
                        }}
                        value={itemDetailsFilter?.fromDate}
                      />
                      <DatePickerInput
                        placeholder="To Date"
                        onChange={(date) => {
                          setItemDetailsFilter({
                            ...itemDetailsFilter,
                            toDate: date,
                          });
                        }}
                        value={itemDetailsFilter?.toDate}
                      />
                    </>
                  </div>
                )}
              </div>

              <div
                className="mt-[1rem]"
                style={{
                  maxHeight: `calc(100% - 11rem)`,
                  minHeight: `calc(100% - 11rem)`,
                  height: `calc(100% - 11rem)`,
                }}
              >
                {dataLoading ? (
                  <LoadingSpinner />
                ) : (
                  <StockDetailsTable
                    onClickItemFn={(rowData) => {
                      if (currentTab === "Batches") {
                        setCurrentBatch(rowData);
                        setBatchOpen(true);
                      } else if (currentTab === "Purchases") {
                        navigate(`/view-purchase-invoice/${rowData?.poit_id}`);
                      } else if (currentTab === "Sales") {
                        navigate(`/view-sales-invoice/${rowData?.soit_id}`);
                      } else if (currentTab === "Alternatives") {
                        navigate(`/view-product/${rowData?.item_id}`);
                      } else if (currentTab === "Vendors") {
                        if (isAdmin) {
                          navigate(`/admin/view-customer/${rowData?.cmr_id}`);
                        } else {
                          navigate(`/view-customer/${rowData?.cmr_id}`);
                        }
                      } else if (currentTab === "Time Line") {
                        if (rowData?.transaction_type === "Sales Invoice") {
                          navigate(
                            `/view-sales-invoice/${rowData?.transaction_ref_id}`
                          );
                        } else if (
                          rowData?.transaction_type === "Purchase Return"
                        ) {
                          navigate(
                            `/view-purchase-return/${rowData?.transaction_ref_id}`
                          );
                        } else if (
                          rowData?.transaction_type === "Purchase Invoice"
                        ) {
                          navigate(
                            `/view-purchase-invoice/${rowData?.transaction_ref_id}`
                          );
                        } else if (
                          rowData?.transaction_type === "Purchase Credit"
                        ) {
                          navigate(
                            `/view-purchase-credit/${rowData?.transaction_ref_id}`
                          );
                        } else if (
                          rowData?.transaction_type === "Sales Return"
                        ) {
                          navigate(
                            `/view-sales-return/${rowData?.transaction_ref_id}`
                          );
                        } else if (
                          rowData?.transaction_type === "Sales Credit"
                        ) {
                          navigate(
                            `/view-sales-credit/${rowData?.transaction_ref_id}`
                          );
                        } else if (
                          rowData?.transaction_type === "Sales Delivery"
                        ) {
                          navigate(
                            `/view-delivery/${rowData?.transaction_ref_id}`
                          );
                        } else if (rowData?.transaction_type === "Stock In") {
                          navigate(
                            `/view-stock-transfer/${rowData?.transaction_ref_id}`
                          );

                          // handle Stock In
                        } else if (rowData?.transaction_type === "Stock Out") {
                          navigate(
                            `/view-stock-transfer/${rowData?.transaction_ref_id}`
                          );
                          // handle Stock Out
                        } else if (rowData?.transaction_type === "GRN") {
                          navigate(
                            `/view-goods/${rowData?.transaction_ref_id}`
                          );
                        } else if (rowData?.transaction_type === "Billing") {
                          navigate(`/view-bill/${rowData?.transaction_ref_id}`);
                        } else {
                          // handle unknown or unsupported transaction types
                        }
                      } else if (currentTab === "Other Stores") {
                        navigate("/add-stock-transfer");
                      }
                    }}
                    setFilterData={setItemDetailsFilter}
                    filterData={itemDetailsFilter}
                    label="Data"
                    paginationProps={paginationProps}
                    tableHeading={
                      currentTab === "Batches"
                        ? BatchesHeading
                        : currentTab === "Purchases"
                        ? purchaseHeading
                        : currentTab === "Sales"
                        ? salesHeading
                        : currentTab === "Alternatives"
                        ? alternativesHeading
                        : currentTab === "Vendors"
                        ? vendorsHeading
                        : currentTab === "Time Line"
                        ? timeLineHeading
                        : currentTab === "Other Stores"
                        ? otherStoresHeading
                        : currentTab === "Warehouse Location"
                        ? warehouseLocationHeading
                        : []
                    }
                    tableBodyData={data || []}
                  />
                )}
              </div>
            </div>
          )}

          <StockDetailsBatchPanel
            setCurrentBatch={setCurrentBatch}
            data={data}
            currentBatch={currentBatch}
            setOpen={setBatchOpen}
            open={batchOpen}
            productDetails={productDetails}
          />
        </div>
      )}
    </InnerLayout>
  );
};

export default StockDetails;

const otherStoresHeading = [
  { label: "STORE CODE", value: "store_code", minWidth: 100 },
  { label: "STORE ADDRESS", value: "shop_address", minWidth: 220 },
  { label: "STORE TYPE", value: "store_type", minWidth: 100 },
  {
    label: "AVAIL. QTY",
    value: "total_quantity",
    minWidth: 80,
    alignment: "right",
  },
  {
    label: "NO. OF BATCHES",
    value: "batch_count",
    minWidth: 100,
    alignment: "right",
  },
  { label: "", value: "actions" },
];

const warehouseLocationHeading = [
  { label: "ITEM CODE", value: "item_code", minWidth: 100 },
  { label: "ITEM NAME", value: "item_name", minWidth: 180 },
  { label: "BATCH NO.", value: "item_batch_number", minWidth: 120 },
  { label: "EXPIRY DATE", value: "item_exp_date", minWidth: 140 },
  { label: "BIN LOCATION", value: "bin_location_no", minWidth: 120 },
  {
    label: "QTY",
    value: "item_quantity",
    minWidth: 80,
    alignment: "right",
  },
  {
    label: "EXPIRED BIN",
    value: "is_expired_bin_location",
    minWidth: 100,
    alignment: "center",
  },
  {
    label: "NON-SELLABLE BIN",
    value: "is_non_sellable_bin_location",
    minWidth: 130,
    alignment: "center",
  },
];

// const BatchesHeading = [
//   {
//     label: "BATCH AGE",
//     value: "batch_age", // new
//     display: false,
//   },
//   {
//     label: "BATCH NO.",
//     value: "item_batch_number",
//     display: false,
//   },
//   {
//     label: "PURCHASE INVOICE NUMBER", // new
//     value: "poit_invoice_number",
//     display: false,
//   },
//   {
//     label: "EXPIRY DATE",
//     value: "item_exp_date",
//     display: true,
//   },
//   {
//     label: "STATUS",
//     value: "stock_status",
//     display: false,
//   },
//   {
//     label: "MRP ₹",
//     value: "item_mrp_price",
//     display: false,
//   },
//   {
//     label: "FINAL PR ₹",
//     value: "item_batch_purchase_rate",
//     display: false,
//   },
//   {
//     label: "SALE RATE ₹",
//     value: "item_batch_sales_rate",
//     display: false,
//   },
//   {
//     label: "MARGIN%",
//     value: "item_batch_margin_percentage",
//     display: false,
//   },
//   {
//     label: "AVAIL. QTY.",
//     value: "item_quantity",
//     display: true,
//   },
//   {
//     label: "PURCHASED QTY",
//     value: "purchase_quantity",
//     display: true,
//   },
//   {
//     label: "NO. OF BILLED TRANSACTIONS",
//     value: "no_of_billed_transaction",
//     display: false,
//   },
//   {
//     label: "NO. OF RETURN TRANSACTIONS",
//     value: "no_of_return_transaction",
//     display: false,
//   },
//   {
//     label: "UOM",
//     value: "item_uom",
//     display: false,
//   },
//   {
//     label: "BIN LOCATION",
//     value: "to_bin_location",
//     display: false,
//   },
//   {
//     label: "CREATED ON",
//     value: "created_date",
//     display: false,
//     type: "date",
//   },
//   {
//     label: "CREATED BY",
//     value: "created_by",
//     display: false,
//   },
//   {
//     label: "UPDATED BY",
//     value: "item_uom",
//     display: false,
//   },
//   {
//     label: "",
//     value: "actions",
//   },
// ];

// const purchaseHeading = [
//   { label: "PURCHASED AGE", value: "purchase_age", display: false },
//   { label: "INVOICE DATE", value: "created_date", display: true, type: "date" },
//   { label: "VENDOR NAME", value: "vendor_name", display: false },
//   { label: "INVOICE NUMBER", value: "poit_invoice_number", display: false },
//   { label: "BATCH NO.", value: "item_batch_number", display: false },
//   { label: "EXPIRY DATE", value: "item_exp_date", display: false },
//   { label: "MRP ₹", value: "item_mrp_price", display: false },
//   { label: "FINAL PR ₹", value: "item_batch_purchase_rate", display: false },
//   { label: "DISC%", value: "item_batch_discount_percentage", display: false },
//   { label: "MARGIN%", value: "item_batch_margin_percentage", display: false },
//   {
//     label: "PROFIT MARGIN VALUE",
//     value: "profit_margin_value",
//     display: false,
//   },
//   { label: "PURCHASE QTY", value: "purchase_quantity", display: false },
//   { label: "TOTAL QTY", value: "total_quantity", display: false },
//   { label: "GST%", value: "item_total_tax_percentage", display: false },
//   { label: "GST AMOUNT", value: "item_tax_amount", display: false },
//   { label: "TOTAL AMOUNT", value: "item_total_amount", display: false },
//   { label: "", value: "actions", display: false },
// ];

// const salesHeading = [
//   { label: "INVOICE DATE", value: "created_date", display: true, type: "date" },
//   { label: "INVOICE NO", value: "soit_invoice_number", display: false },
//   { label: "SOLD TO", value: "cmr_name", display: false },
//   { label: "BATCH NO.", value: "item_batch_number", display: false },
//   { label: "PRODUCT", value: "item_name", display: false },
//   { label: "MRP ₹", value: "item_mrp_price", display: false },
//   { label: "SALES RATE", value: "item_batch_sales_rate", display: false },
//   { label: "DISC%", value: "item_batch_discount_percentage", display: false },
//   { label: "GST%", value: "item_batch_tax_percentage", display: false },
//   { label: "TOTAL AMOUNT", value: "item_total_amount", display: false },
//   // { label: "PROFIT", value: "profit", display: false },
//   { label: "MARGIN%", value: "sot_margin_percentage", display: false },
//   { label: "QTY SOLD", value: "sold_quantity", display: false },
//   { label: "SALES BY", value: "sales_by", display: false },
//   { label: "RACK LOCATION", value: "item_rack_location", display: false },
//   { label: "PAYMENT METHOD", value: "soit_payment_method", display: false },
//   { label: "RETURN STATUS", value: "sot_return_status", display: false },
//   { label: "", value: "actions", display: false },
// ];

// const alternativesHeading = [
//   { label: "ID", value: "item_id", display: false },
//   { label: "PRODUCT CODE", value: "item_code", display: false },
//   { label: "PRODUCT NAME", value: "item_name", display: false },
//   { label: "BATCH NO.", value: "item_batch_number", display: false },
//   { label: "BIN", value: "to_bin_location", display: false },
//   { label: "EXPIRY", value: "item_exp_date", display: false },
//   { label: "STATUS", value: "stock_status", display: false },
//   { label: "SELLABLE QTY", value: "item_sellable_quantity", display: false },
//   {
//     label: "NON-SELLABLE QTY",
//     value: "item_non_sellable_quantity",
//     display: false,
//   },
//   { label: "MRP", value: "item_mrp_price", display: false },
//   { label: "SALE RATE", value: "item_batch_sales_rate", display: false },
//   { label: "MARGIN%", value: "item_batch_margin_percentage", display: false },
//   { label: "PRICE DIFFERENCE", value: "price_diffrence", display: true },
//   { label: "VENDOR", value: "cmr_name", display: false },
//   { label: "Actions", value: "action", display: false }, // Set false to keep consistency
// ];

// const vendorsHeading = [
//   { label: "VENDOR", value: "cmr_first_name", display: false },
//   { label: "GSTIN", value: "cmr_gstin", display: false },
//   { label: "CONTACT", value: "cmr_phone_number", display: false },
//   // { label: "CREDIT TIME (DAYS)", value: "credit_days", display: false },
//   { label: "CREDIT LIMIT ₹", value: "credit_limit", display: false },
//   {
//     label: "LAST TRANSACTION DATE",
//     value: "last_transaction_date",
//     display: false,
//     type: "date",
//   },
//   { label: "Actions", value: "action", display: false }, // Set false to keep consistency
// ];

// const timeLineHeading = [
//   {
//     label: "TXN DATE",
//     value: "transaction_date",
//     display: false,
//     type: "date",
//   },
//   { label: "TXN TYPE", value: "transaction_type", display: false },
//   { label: "TXN NO", value: "invoice_number", display: false },
//   { label: "PARTY NAME", value: "vendor_name", display: false },
//   {
//     label: "LINKED INVOICE NO",
//     value: "linked_invoice_number",
//     display: false,
//   },
//   { label: "BATCH NO", value: "batch_number", display: false },
//   { label: "QTY IN", value: "quantity_in", display: false },
//   { label: "QTY OUT", value: "quantity_out", display: false },
//   { label: "AVAILABLE QTY", value: "quantity", display: false },
//   { label: "FINAL RATE", value: "final_rate", display: false },
//   { label: "DISC %", value: "discount_percentage", display: false },
//   { label: "GST %", value: "tax_percentage", display: false },
//   { label: "BIN LOCATION", value: "bin_location", display: false },
//   { label: "CREATED BY", value: "created_by", display: false },
//   { label: "EXPIRY DATE", value: "expiry_date", display: false, type: "date" },
//   { label: "Actions", value: "action", display: false }, // Set false to keep consistency
// ];

// const otherStoresheading = [
//   { label: "Store Code", value: "store_code", display: false },
//   { label: "Store Address", value: "store_address", display: false },
//   { label: "Store Type", value: "store_type", display: false },
//   { label: "Product Expiry Status", value: "expiry_status", display: false },
//   { label: "Stock Status", value: "stock_status", display: false },
//   { label: "MRP Range", value: "max_mrp_range", display: false },
//   { label: "Sale Rate Range", value: "sale_rate_range", display: false },
//   { label: "Available Qty", value: "available_qty", display: false },
//   { label: "No. of Batches", value: "batch_count", display: false },
//   // { label: "Actions", value: "action", display: false }, // Set false to keep consistency
// ];
